// @flow

import React from 'react';
import { localize, unescaped } from '@ta/common.i18n';
import TripModalLink from '@ta/trips.trip-modal-links';
import { isTripUser } from '@ta/trips.trip-util';
import { InteractionLogger } from '@ta/tracking.interactions';

import { getPhoto } from './shared';
import styles from './DmoTripCard.less';

const DmoTripCard = ({ trip }: { trip: any }) => {
  const trackingParams = {
    contentType: 'TRIP',
    contentId: trip.id,
    sponsoredBy: trip.owner.userId,
  };
  return (
    <InteractionLogger>
      {logInteraction => (
        <React.Fragment>
          <div className={styles.tripPhotoContainer}>
            <TripModalLink
              tripModalDescriptor={{
                isUser: isTripUser(trip),
                href: trip.route?.url,
                navigator: { id: trip.id, title: trip.title },
              }}
              onClick={e => {
                logInteraction(e, 'rightRailDestinationSpotlightClick', trackingParams);
              }}
            >
              {getPhoto(trip?.photo, styles.placeholder, 'suitcase')}
            </TripModalLink>
          </div>
          <div className={styles.tripDetailsContainer}>
            <TripModalLink
              tripModalDescriptor={{
                isUser: isTripUser(trip),
                href: trip.route?.url,
                navigator: { id: trip.id, title: trip.title },
              }}
              onClick={e => {
                logInteraction(e, 'rightRailDestinationSpotlightClick', trackingParams);
              }}
            >
              <div className={styles.tripTitleContainer}>{trip?.title}</div>
            </TripModalLink>
            <span className={styles.featuring}>
              {unescaped(
                localize('trips_home_featuring_count_v3', {
                  '0': styles.places,
                  '1': trip?.items.length || 0,
                }),
              )}
            </span>
          </div>
        </React.Fragment>
      )}
    </InteractionLogger>
  );
};

export default DmoTripCard;
